'use client'

import { useEffect } from 'react'

import { cookiesDataByName, useCookie } from '@marketplace-web/environment/cookies-util'

const IncrementVisitCount = ({ visitsCount }: { visitsCount: number }) => {
  const cookie = useCookie()

  useEffect(() => {
    cookie.set(cookiesDataByName.seller_header_visits, String(visitsCount + 1))
  }, [cookie, visitsCount])

  return null
}

export default IncrementVisitCount
